// All possible parameters with can access to KBE
var SEARCH_IDS = ['skd-search-id', 'skd-searchId', 'searchId'];

// These parameters continues over all flow in the URL to display to user
var PARAMETERS_NAMES = {
  CHECKIN: 'skd-checkin',
  CHECKOUT: 'skd-checkout',
  CHANNEL_ID: 'skd-channel-id',
  ADULT_ROOM: 'adult_room',
  CHILD_ROOM: 'child_room',
  TOTAL_ROOMS: 'skd-total-rooms',
  LANGUAGE: 'skd-language-code',
  CURRENCY_CODE: 'skd-currency-code',
  PROMOTION_CODE: 'skd-promotion-code',
  HIDE_TRANSLATIONS: 'skd-show-wti-keys',
  PROPERTY_CODE: 'skd-property-code',
  OFFER_PACKAGE: 'skd-offer-package',
  OFFER_ROOM: 'skd-offer-room',
  OFFER_RATE: 'skd-offer-rate',
  PRICE_TYPE: 'skd-price-type',
  PRICE_TIME_BASE: 'skd-time-price-base',
  PRICE: 'skd-price',
  CONFIRM_BOOKING_ID: 'skd-confirm-booking-id',
  CONFIRM_BOOKING_PIN: 'skd-confirm-booking-pin',
  BOOKING_ID: 'skd-booking-id',
  BOOKING_PIN: 'skd-booking-pin',
  BOOKING_ENGINE: 'skd-booking-engine',
  PROPERTIES_PAGE_SIZE: 'skd-properties-page-size',
  PROPERTIES_PAGE: 'skd-properties-page',
  OPEN_OCCUPANCY_SELECTOR: 'skd-open-occupancy-selector',
  SCROLL_TO_ROOM: 'skd-scroll-to-room',
  CONTINUE_BOOKING: 'skd-continue-booking',
  SUBSCRIPTION_ID: 'skd-subscription-id',
  SUBSCRIPTION_HASH: 'skd-subscription-hash',
  RATE_FENCE: 'skd-ratefence',
  SEARCH_ID: 'skd-search-id',
  USER_IP: 'skd-user-ip',
  WIDGET_ID: 'kbe-widget-id',
  WIDGET_SECTION: 'kbe-widget-section',
  IS_META_REDIRECT: 'skd-is-meta-redirect',
  SORT_ORDER: 'data-skd-sort-order',
  SHOW_DEMO_PROPERTIES: 'show-demo-properties',
  HOTELS_LIST_VIEW: 'hotels-list-view',
  QA: 'qa',
  RC: 'rc',
  DEBUG_MODE: 'debug-mode',
  GUID: 'guid',
  PACKAGE_VIEW: 'skd-package-view',
  PACKAGES_FIRST: 'skd-packages-first',
  PAYMENT_NFO: 'payment-info',
  // has to be always base64 encoded
  ROOM_VIEW: 'skd-room-view',
  TRUST_YOU_ID: 'trust-you-id',
  NEW_TAB_DISABLED: 'skd-disable-new-tab',
  CUSTOM_CLASSIFICATIONS: 'custom-classifications',
  HOTEL_SELECTED_FROM_MAP: 'hotel-selected-from-map',
  CUSTOM_CLASSIFICATION_FROM_MAP: 'custom-classification-from-map',
  CUSTOM_CLASSIFICATION_FROM_MAP_TITLE: 'custom-classification-from-map-title',
  SEARCHBAR_TYPE: 'searchbar-type',
  SEARCHBAR_CODE: 'searchbar-code',
  SEARCHBAR_LABEL: 'searchbar-label',
  ALLOW_ON_THE_FLY_STYLE_UPDATES: 'allow-on-the-fly-style-updates',
  HOTEL_SELECTED_FROM_CAROUSEL: 'hotel-selected-from-carousel',
  GEO_REGION_ID: 'geo-region-id',
  IS_NEW_BOOKING: 'is-new-booking',
  COUPON: 'COUPON',
  REWARD_PROGRAM: 'reward-program',
  FIXED_REWARD_PROGRAM: 'fixed-reward-program',
  ENABLE_PAYMENT_LIBRARY: 'enable-payment-library',
  FILTER_PARAMS_PRICERANGE_FROM: 'skd-filter-params-price-range-from',
  FILTER_PARAMS_PRICERANGE_TO: 'skd-filter-params-price-range-to',
  FILTER_PARAMS_COUNTRY: 'skd-filter-params-country',
  FILTER_PARAMS_MEALPLAN: 'skd-filter-params-mealplan',
  FILTER_PARAMS_PROPERTY_TYPE: 'skd-filter-params-property-type'
};

/**
 * @type {Object<string, string | boolean>} Parameters that are referenced in the  system and have a known name
 * @proerty {string} name the param name in url
 * @proerty {string} translation the name the param will have in url object at redux
 * @proerty {boolean} maintain if the param is kept in browser url along navigation
 * @proerty {boolean} canBeEmpty if param is allowed to not have value
 */
var QUERY_PARAMETERS = {
  IS_NEW_BOOKING: {
    name: PARAMETERS_NAMES.IS_NEW_BOOKING,
    translation: 'isNewBooking',
    maintain: true,
    canBeEmpty: false
  },
  COUPON: {
    name: PARAMETERS_NAMES.COUPON,
    translation: 'coupon',
    maintain: true,
    canBeEmpty: false
  },
  CUSTOM_CLASSIFICATIONS: {
    name: PARAMETERS_NAMES.CUSTOM_CLASSIFICATIONS,
    translation: 'customClassifications',
    maintain: true,
    canBeEmpty: false
  },
  HOTEL_SELECTED_FROM_MAP: {
    name: PARAMETERS_NAMES.HOTEL_SELECTED_FROM_MAP,
    translation: 'hotelSelectedFromMap',
    maintain: true,
    canBeEmpty: false
  },
  PACKAGE_VIEW: {
    name: PARAMETERS_NAMES.PACKAGE_VIEW,
    translation: 'packageView',
    maintain: true,
    canBeEmpty: false
  },
  PACKAGES_FIRST: {
    name: PARAMETERS_NAMES.PACKAGES_FIRST,
    translation: 'packagesFirst',
    maintain: true,
    canBeEmpty: false
  },
  RC: {
    name: PARAMETERS_NAMES.RC,
    translation: 'RC',
    maintain: false,
    canBeEmpty: false
  },
  IS_META_REDIRECT: {
    name: PARAMETERS_NAMES.IS_META_REDIRECT,
    translation: 'isMetaRedirect',
    maintain: false,
    canBeEmpty: false
  },
  QA: {
    name: PARAMETERS_NAMES.QA,
    translation: 'QA',
    maintain: true,
    canBeEmpty: true
  },
  SOURCE_CONTEXT: {
    name: PARAMETERS_NAMES.SEARCH_ID,
    translation: 'sourceContext',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  CHANNEL_ID: {
    name: PARAMETERS_NAMES.CHANNEL_ID,
    translation: 'channelId',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  CHECKIN: {
    name: PARAMETERS_NAMES.CHECKIN,
    translation: 'checkin',
    maintain: true,
    common: false,
    canBeEmpty: false
  },
  CHECKOUT: {
    name: PARAMETERS_NAMES.CHECKOUT,
    translation: 'checkout',
    maintain: true,
    common: false,
    canBeEmpty: false
  },
  ADULT_ROOM: {
    name: PARAMETERS_NAMES.ADULT_ROOM,
    translation: 'adultRoom',
    maintain: true,
    common: false,
    canBeEmpty: false
  },
  CHILD_ROOM: {
    name: PARAMETERS_NAMES.CHILD_ROOM,
    translation: 'childRoom',
    maintain: true,
    common: false,
    canBeEmpty: false
  },
  TOTAL_ROOMS: {
    name: PARAMETERS_NAMES.TOTAL_ROOMS,
    translation: 'totalRooms',
    maintain: true,
    common: false,
    canBeEmpty: false
  },
  LANGUAGE: {
    name: PARAMETERS_NAMES.LANGUAGE,
    translation: 'language',
    maintain: true,
    common: false,
    canBeEmpty: false
  },
  CURRENCY_CODE: {
    name: PARAMETERS_NAMES.CURRENCY_CODE,
    translation: 'currencyCode',
    maintain: true,
    common: false,
    canBeEmpty: false
  },
  PROMOTION_CODE: {
    name: PARAMETERS_NAMES.PROMOTION_CODE,
    translation: 'promotionCode',
    maintain: true,
    common: false,
    canBeEmpty: false
  },
  HIDE_TRANSLATIONS: {
    name: PARAMETERS_NAMES.HIDE_TRANSLATIONS,
    translation: 'hideTranslations',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  RATE_FENCE: {
    name: PARAMETERS_NAMES.RATE_FENCE,
    translation: 'rateFence',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  PROPERTY_CODE: {
    name: PARAMETERS_NAMES.PROPERTY_CODE,
    translation: 'propertyCode',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  OFFER_PACKAGE: {
    name: PARAMETERS_NAMES.OFFER_PACKAGE,
    translation: 'packageCode',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  OFFER_ROOM: {
    name: PARAMETERS_NAMES.OFFER_ROOM,
    translation: 'offerRoom',
    maintain: false,
    common: false,
    canBeEmpty: false
  },
  OFFER_RATE: {
    name: PARAMETERS_NAMES.OFFER_RATE,
    translation: 'offerRate',
    maintain: false,
    common: false,
    canBeEmpty: false
  },
  PRICE_TYPE: {
    name: PARAMETERS_NAMES.PRICE_TYPE,
    translation: 'priceType',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  PRICE_TIME_BASE: {
    name: PARAMETERS_NAMES.PRICE_TIME_BASE,
    translation: 'priceTimeBase',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  PRICE: {
    name: PARAMETERS_NAMES.PRICE,
    translation: 'price',
    maintain: false,
    common: true,
    canBeEmpty: false
  },
  CONFIRM_BOOKING_ID: {
    name: PARAMETERS_NAMES.CONFIRM_BOOKING_ID,
    translation: 'confirmationId',
    maintain: false,
    common: true,
    canBeEmpty: false
  },
  BOOKING_ID: {
    name: PARAMETERS_NAMES.BOOKING_ID,
    translation: 'reservationId',
    maintain: false,
    common: true,
    canBeEmpty: false
  },
  CONTINUE_BOOKING: {
    name: PARAMETERS_NAMES.CONTINUE_BOOKING,
    translation: 'continueBookingId',
    maintain: false,
    common: true,
    canBeEmpty: false
  },
  CONFIRM_BOOKING_PIN: {
    name: PARAMETERS_NAMES.CONFIRM_BOOKING_PIN,
    translation: 'reservationPin',
    maintain: false,
    common: true,
    canBeEmpty: false
  },
  BOOKING_PIN: {
    name: PARAMETERS_NAMES.BOOKING_PIN,
    translation: 'reservationPin',
    maintain: false,
    common: true,
    canBeEmpty: false
  },
  BOOKING_ENGINE: {
    name: PARAMETERS_NAMES.BOOKING_ENGINE,
    translation: 'activeBookingEngine',
    maintain: false,
    common: true,
    canBeEmpty: false
  },
  PROPERTIES_PAGE_SIZE: {
    name: PARAMETERS_NAMES.PROPERTIES_PAGE_SIZE,
    translation: 'propertiesPageSize',
    maintain: true,
    common: false,
    canBeEmpty: false
  },
  PROPERTIES_PAGE: {
    name: PARAMETERS_NAMES.PROPERTIES_PAGE,
    translation: 'propertiesPage',
    maintain: true,
    common: false,
    canBeEmpty: false
  },
  OPEN_OCCUPANCY_SELECTOR: {
    name: PARAMETERS_NAMES.OPEN_OCCUPANCY_SELECTOR,
    translation: 'openOccupancySelector',
    maintain: false,
    common: true,
    canBeEmpty: true
  },
  SCROLL_TO_ROOM: {
    name: PARAMETERS_NAMES.SCROLL_TO_ROOM,
    translation: 'scrollToRoom',
    maintain: false,
    common: false,
    canBeEmpty: false
  },
  SUBSCRIPTION_ID: {
    name: PARAMETERS_NAMES.SUBSCRIPTION_ID,
    translation: 'subscriptionId',
    maintain: false,
    common: true,
    canBeEmpty: false
  },
  SUBSCRIPTION_HASH: {
    name: PARAMETERS_NAMES.SUBSCRIPTION_HASH,
    translation: 'subscriptionHash',
    maintain: false,
    common: true,
    canBeEmpty: false
  },
  USER_IP: {
    name: PARAMETERS_NAMES.USER_IP,
    translation: 'ipAddress',
    maintain: true,
    common: false,
    canBeEmpty: false
  },
  WIDGET_ID: {
    name: PARAMETERS_NAMES.WIDGET_ID,
    translation: 'widgetId',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  WIDGET_SECTION: {
    name: PARAMETERS_NAMES.WIDGET_SECTION,
    translation: 'widgetSection',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  SORT_ORDER: {
    name: PARAMETERS_NAMES.SORT_ORDER,
    translation: 'sortOrder',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  SHOW_DEMO_PROPERTIES: {
    name: PARAMETERS_NAMES.SHOW_DEMO_PROPERTIES,
    translation: 'showDemoProperties',
    maintain: true,
    canBeEmpty: true
  },
  HOTELS_LIST_VIEW: {
    name: PARAMETERS_NAMES.HOTELS_LIST_VIEW,
    translation: 'hotelsListView',
    maintain: true,
    canBeEmpty: false
  },
  GUID: {
    name: PARAMETERS_NAMES.GUID,
    translation: 'GUID',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  DEBUG_MODE: {
    name: PARAMETERS_NAMES.DEBUG_MODE,
    translation: 'debugMode',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  PAYMENT_NFO: {
    name: PARAMETERS_NAMES.PAYMENT_NFO,
    translation: 'paymentInfo',
    maintain: true,
    canBeEmpty: false
  },
  ROOM_VIEW: {
    name: PARAMETERS_NAMES.ROOM_VIEW,
    translation: 'roomView',
    maintain: true
  },
  TRUST_YOU_ID: {
    name: PARAMETERS_NAMES.TRUST_YOU_ID,
    translation: 'trustYouId',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  NEW_TAB_DISABLED: {
    name: PARAMETERS_NAMES.NEW_TAB_DISABLED,
    translation: 'newTabDisabled',
    maintain: true,
    common: true,
    canBeEmpty: true
  },
  CUSTOM_CLASSIFICATION_FROM_MAP: {
    name: PARAMETERS_NAMES.CUSTOM_CLASSIFICATION_FROM_MAP,
    translation: 'customClassificationFromMap',
    maintain: true,
    canBeEmpty: true
  },
  CUSTOM_CLASSIFICATION_FROM_MAP_TITLE: {
    name: PARAMETERS_NAMES.CUSTOM_CLASSIFICATION_FROM_MAP_TITLE,
    translation: 'customClassificationFromMapTitle',
    maintain: true,
    canBeEmpty: true
  },
  SEARCHBAR_TYPE: {
    name: PARAMETERS_NAMES.SEARCHBAR_TYPE,
    translation: 'searchbarType',
    maintain: true,
    canBeEmpty: true
  },
  SEARCHBAR_CODE: {
    name: PARAMETERS_NAMES.SEARCHBAR_CODE,
    translation: 'searchbarCode',
    maintain: true,
    canBeEmpty: true
  },
  SEARCHBAR_LABEL: {
    name: PARAMETERS_NAMES.SEARCHBAR_LABEL,
    translation: 'searchbarLabel',
    maintain: true,
    canBeEmpty: true
  },
  ALLOW_ON_THE_FLY_STYLE_UPDATES: {
    name: PARAMETERS_NAMES.ALLOW_ON_THE_FLY_STYLE_UPDATES,
    translation: 'allowOnTheFlyStyleUpdates',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  HOTEL_SELECTED_FROM_CAROUSEL: {
    name: PARAMETERS_NAMES.HOTEL_SELECTED_FROM_CAROUSEL,
    translation: 'hotelSelectedFromCarousel',
    maintain: true,
    canBeEmpty: false
  },
  GEO_REGION_ID: {
    name: PARAMETERS_NAMES.GEO_REGION_ID,
    translation: 'geoRegionId',
    maintain: true,
    canBeEmpty: false
  },
  REWARD_PROGRAM: {
    name: PARAMETERS_NAMES.REWARD_PROGRAM,
    translation: 'rewardProgram',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  FIXED_REWARD_PROGRAM: {
    name: PARAMETERS_NAMES.FIXED_REWARD_PROGRAM,
    translation: 'fixedRewardProgram',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  ENABLE_PAYMENT_LIBRARY: {
    name: PARAMETERS_NAMES.ENABLE_PAYMENT_LIBRARY,
    translation: 'enablePaymentLibrary',
    maintain: true,
    common: true,
    canBeEmpty: false
  },
  FILTER_PARAMS_PRICERANGE_FROM: {
    name: PARAMETERS_NAMES.FILTER_PARAMS_PRICERANGE_FROM,
    translation: 'filterParamsFilterParamsPriceRangeFrom',
    maintain: true,
    canBeEmpty: true
  },
  FILTER_PARAMS_PRICERANGE_TO: {
    name: PARAMETERS_NAMES.FILTER_PARAMS_PRICERANGE_TO,
    translation: 'filterParamsFilterParamsPriceRangeTo',
    maintain: true,
    canBeEmpty: true
  },
  FILTER_PARAMS_COUNTRY: {
    name: PARAMETERS_NAMES.FILTER_PARAMS_COUNTRY,
    translation: 'filterParamsFilterParamsCountry',
    maintain: true,
    canBeEmpty: true
  },
  FILTER_PARAMS_MEALPLAN: {
    name: PARAMETERS_NAMES.FILTER_PARAMS_MEALPLAN,
    translation: 'filterParamsFilterParamsMealPlan',
    maintain: true,
    canBeEmpty: true
  },
  FILTER_PARAMS_PROPERTY_TYPE: {
    name: PARAMETERS_NAMES.FILTER_PARAMS_PROPERTY_TYPE,
    translation: 'filterParamsFilterParamsPropertyType',
    maintain: true,
    canBeEmpty: true
  }
};
var QUERY_PARAMETERS_CONFIG = {
  DATE_FORMAT: 'YYYY-MM-DD',
  DEFAULT_TOTAL_QUERY_ROOM: 1
};

var getParametersToMaintain = function getParametersToMaintain() {
  return Object.keys(QUERY_PARAMETERS).filter(function (param) {
    return QUERY_PARAMETERS[param].maintain;
  });
};
var getAllParametersNames = function getAllParametersNames() {
  return Object.values(PARAMETERS_NAMES);
};
var getAllParametersTranslations = function getAllParametersTranslations() {
  return Object.values(QUERY_PARAMETERS).map(function (queryParamObject) {
    return queryParamObject.translation;
  });
};

// Detects and returns all params for occupancy
var getOccupancyParams = function getOccupancyParams(queryParams) {
  var query = {};
  var child = QUERY_PARAMETERS.CHILD_ROOM.name;
  var childLength = child.length;
  var adult = QUERY_PARAMETERS.ADULT_ROOM.name;
  var adultLength = adult.length;
  var occupancyParameters = Object.keys(queryParams).filter(function (param) {
    return param.substring(0, childLength) === child || param.substring(0, adultLength) === adult;
  });
  occupancyParameters.forEach(function (occupancyParameterName) {
    query[occupancyParameterName] = queryParams[occupancyParameterName];
  });
  return query;
};

/**
 * Receives the url object from redux and returns an object with the params to be put in browser url
 *
 * @param {object} queryParams
 * @returns {object} Params to be put in browser url
 */
var getCurrentQueryParams = function getCurrentQueryParams(queryParams) {
  var query = {};
  getParametersToMaintain().forEach(function (parameter) {
    var _QUERY_PARAMETERS$par = QUERY_PARAMETERS[parameter],
      name = _QUERY_PARAMETERS$par.name,
      translation = _QUERY_PARAMETERS$par.translation,
      canBeEmpty = _QUERY_PARAMETERS$par.canBeEmpty;
    var value = queryParams[translation];
    // added value distinct of null condition because typeof null is object
    var hasValue = typeof value !== 'undefined' && value !== null;
    if (hasValue) {
      if (value !== '' || canBeEmpty) {
        if (name === QUERY_PARAMETERS.QA.name) {
          query[name] = true;
        } else {
          query[name] = value;
        }
      }
    }
  });
  var all = Object.assign(query, getOccupancyParams(queryParams));
  var domain = queryParams.domain;
  if (domain) {
    all.domain = domain;
  }
  var parametersNames = getAllParametersNames();
  var parametersTranslations = getAllParametersTranslations();

  // This is to also maintain the params that are not known beforehand by the system
  var notKnownQueryParamsKeys = Object.keys(queryParams).filter(function (key) {
    return key !== 'domain' && !parametersNames.includes(key) && !parametersTranslations.includes(key);
  });
  notKnownQueryParamsKeys.forEach(function (key) {
    all[key] = queryParams[key] || undefined;
  });
  return all;
};
var index = {
  getOccupancyParams: getOccupancyParams,
  getParametersToMaintain: getParametersToMaintain,
  getAllParametersNames: getAllParametersNames,
  getCurrentQueryParams: getCurrentQueryParams,
  getAllParametersTranslations: getAllParametersTranslations,
  SEARCH_IDS: SEARCH_IDS,
  QUERY_PARAMETERS: QUERY_PARAMETERS,
  QUERY_PARAMETERS_CONFIG: QUERY_PARAMETERS_CONFIG,
  PARAMETERS_NAMES: PARAMETERS_NAMES
};

var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': index
});

export { index$1 as a, index as i };
